import api from '@/services/api';
import * as MUTATION from '@/services/store/mutation-types';
import * as ACTION from '@/services/store/action-types';

const StoreModule = class {
  constructor(properties = {}) {
    this.ACTION = ACTION;
    this.MUTATION = MUTATION;

    this.namespaced = true;

    this.api = api;
    this.endpoint = properties.endpoint || '';

    this.state = properties.state || {};
    this.mutations = properties.mutations || {};
    this.actions = properties.actions || {};
    this.getters = properties.getters || {};
    this.callbacks = properties.callbacks || {};
  }
};

export default StoreModule;
